import dansk from 'constants/lang-dansk';
import deutsche from 'constants/lang-deutsche';
import english from 'constants/lang-english';
import norsk from 'constants/lang-norsk';
import svenska from 'constants/lang-svenska';

const languages = ['dansk', 'english', 'deutsche', 'norsk', 'svenska'];

const languageObject = [
    { id: 'dansk', name: 'Dansk', code: 'name_da', langCode: 'da' },
    { id: 'english', name: 'English', code: 'name_en', langCode: 'en' },
    { id: 'norsk', name: 'Norsk', code: 'name_no', langCode: 'no' },
    { id: 'svenska', name: 'Svenska', code: 'name_sv', langCode: 'sv' },
    { id: 'deutsche', name: 'Deutsche', code: 'name_de', langCode: 'de' },
];

const translationResource = {
    dansk: { translation: dansk },
    english: { translation: english },
    deutsche: { translation: deutsche },
    norsk: { translation: norsk },
    svenska: { translation: svenska },
};

const languageMapper: Record<string, string> = {
    da: 'dansk',
    en: 'english',
    de: 'deutsche',
    no: 'norsk',
    se: 'svenska',
};

export { languages, translationResource, languageObject, languageMapper };
